<template>
    <span>
        <button class="btn-link"
                @click="viewItem()">
            <slot name="modal-link"></slot>
        </button>
        <!-- added close directive in order to reset the modal state -->
        <modal  :show.sync="modals.classic" @close="resetModal" headerClasses="justify-content-center">
          <center>
            <Header  :pageTitle="pageTitle" class="card-container"></Header>
            <hr/>
             <div class="col-md-12 center"></div>   
            <div>
                    <label>Country</label>
                    <v-select v-model="financeOffice['countryId']" name="CountryDropdown" :reduce="item => item.countryId" label="name" :options="countriesOptions" placeholder="Please select a country."></v-select>

                </div>
                <div>
                    <label>Name</label>
                    <base-input v-model="financeOffice['name']" name="Name" placeholder="Please enter a name."></base-input>
                </div>
                <div>
                    <label>Email</label>
                    <base-input v-model="financeOffice['email']" name="Email" placeholder="Please enter an email."></base-input>
                </div>
                <div>
                    <label>Address</label>
                    <base-input v-model="financeOffice['address']" name="Address" placeholder="Please enter an address."></base-input>
                </div>
                <div>
                    <label>DSN Phone Number</label>
                    <base-input v-model="financeOffice['dsnPhoneNumber']" name="DsnPhoneNumber" placeholder="Please enter a DSN phone number."></base-input>
                </div>
                <div>
                    <label>Commercial Phone Number</label>
                    <base-input v-model="financeOffice['commercialPhoneNumber']" name="CommercialPhoneNumber" placeholder="Please enter a commercial phone number."></base-input>
                </div>
                <hr/>
             <div class="row justify-content-center text-center ">
                <div>
                    <base-button @click="returnToEditFinanceOfficesDashboard()" class="btn btn-primary" v-b-popover.hover.bottom="'Navigate back to edit finance offices dashboard.'">
                        <i class="tim-icons icon-double-left center-btn-content"></i> Return to Table
                    </base-button>
                </div>
                <div >
                    <base-button @click="saveFinanceOffice()" type="primary" v-b-popover.hover.bottom="'Save changes.'">
                        <i class="tim-icons icon-bank center-btn-content"></i> Save Changes
                    </base-button>
                </div>
                </div>
</center>
        </modal>
    </span>
</template>

<script>
import Header from "@/components/App/Header.vue";
import { BaseButton, Modal } from "@/components";

import axios from "@/axios";
import {
    mapGetters,
    mapActions
} from "vuex";

export default {
    name: 'EditFinanceOffice',
    components: {
        Header,
        Modal
    },
    data() {
        return {
            financeOffice: [],
              modals: {
                    classic: false,
                },
        };
    },
      props: {  
    id: {
      default: 0
    },
        },
    computed: {
        ...mapGetters({
            countriesOptions: 'countries/allCountries',
        }),
        pageTitle() {
            return `Edit Finance Office`
        },
    },
   
    methods: {
        ...mapActions({
            getAllCountries: 'countries/getAllCountries'
        }),
        returnToEditFinanceOfficesDashboard() {
             this.modals.classic = false;
        },
        getFinanceOffice() {
            axios
                .get(`api/financialoffices/${this.id}`)
                .then((response) => {
                    this.financeOffice = response.data
                });
        },
        viewItem(){
             this.getFinanceOffice()
        this.getAllCountries().then(()=>{
             this.modals.classic = true;
        })

        },
          resetModal() {
                this.financeOffice = null;
                this.errors.clear(); // clears all validation errors
                this.$validator.reset(); // reset the validator
                this.modals = this.modals || {}; 
                this.modals.classic = false;
            },
           
        saveFinanceOffice() {
            axios
                .post("api/financialoffices", this.financeOffice)
                .then((response) => {
                    this.getFinanceOffice()
                    this.modals.classic = false;
                });

        }
    }
};
</script>

<style scoped>
.center-btn-content {
 height:18px; margin-right: 3px
}
.card label {
   
    color: black !important;
}

.card h3, .card h4, .card h5, .card h6, .card p {
    color: rgba(255, 255, 255, 0.8);
    padding: 0px;
}
</style>